import React from 'react'

const AI = ({ai}) => {
  return (
    <div className='ai-setup'>
        {ai.image && <img src={ai.image} alt="" />}
        {ai.about && <p>{ai.about}</p>}
    </div>
  )
}

export default AI